import React from "react";

const Footer = () => {
	return (
		<footer className="w-full absolute bottom-0 bg-white py-3 text-center">
			<p className="md:text-lg">
				&copy; 2021{" "}
				<a href="https://github.com/vatsal0601" className="font-semibold text-green-600">
					Vatsal Sakariya
				</a>
				. All rights reserved.
			</p>
		</footer>
	);
};

export default Footer;
